import React from 'react';

const Component = props => {
	return (
		<>
			<p>ERROR 404</p>
		</>
	);
};

export default Component;
